import "./CartPrice.css";

interface CartPriceProps {
  price: number;
}

export const CartPrice = ({ price }: CartPriceProps) => {
  return <p className="cart-price">{price} ₽</p>;
};
